import { PBRMaterial } from "@babylonjs/core/Materials/PBR/pbrMaterial";
import { GLTFLoader } from "../glTFLoader";
var NAME = "KHR_materials_ior";
/**
 * [Proposed Specification](https://github.com/KhronosGroup/glTF/pull/1718)
 * !!! Experimental Extension Subject to Changes !!!
 */

var KHR_materials_ior = function () {
  /** @hidden */
  function KHR_materials_ior(loader) {
    /**
     * The name of this extension.
     */
    this.name = NAME;
    /**
     * Defines a number that determines the order the extensions are applied.
     */

    this.order = 180;
    this._loader = loader;
    this.enabled = this._loader.isExtensionUsed(NAME);
  }
  /** @hidden */


  KHR_materials_ior.prototype.dispose = function () {
    this._loader = null;
  };
  /** @hidden */


  KHR_materials_ior.prototype.loadMaterialPropertiesAsync = function (context, material, babylonMaterial) {
    var _this = this;

    return GLTFLoader.LoadExtensionAsync(context, material, this.name, function (extensionContext, extension) {
      var promises = new Array();
      promises.push(_this._loader.loadMaterialPropertiesAsync(context, material, babylonMaterial));
      promises.push(_this._loadIorPropertiesAsync(extensionContext, extension, babylonMaterial));
      return Promise.all(promises).then(function () {});
    });
  };

  KHR_materials_ior.prototype._loadIorPropertiesAsync = function (context, properties, babylonMaterial) {
    if (!(babylonMaterial instanceof PBRMaterial)) {
      throw new Error(context + ": Material type not supported");
    }

    if (properties.ior !== undefined) {
      babylonMaterial.indexOfRefraction = properties.ior;
    } else {
      babylonMaterial.indexOfRefraction = KHR_materials_ior._DEFAULT_IOR;
    }

    return Promise.resolve();
  };
  /**
   * Default ior Value from the spec.
   */


  KHR_materials_ior._DEFAULT_IOR = 1.5;
  return KHR_materials_ior;
}();

export { KHR_materials_ior };
GLTFLoader.RegisterExtension(NAME, function (loader) {
  return new KHR_materials_ior(loader);
});